import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SVGComponent(props) {
  return (
    <Svg
      width={25}
      height={16}
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M21.134 0H6.57278C4.77791 0 3.31167 1.33984 3.05887 3.05887C1.33984 3.28639 0 4.77791 0 6.57278V12.1849C0 14.1315 1.59264 15.7241 3.53919 15.7241H18.0752C19.87 15.7241 21.3363 14.3843 21.5891 12.6652C23.3081 12.4377 24.6479 10.9462 24.6479 9.15133V3.53919C24.6732 1.59264 23.0806 0 21.134 0ZM20.6284 12.1849C20.6284 13.5753 19.4908 14.7129 18.1004 14.7129H3.53919C2.14879 14.7129 1.0112 13.5753 1.0112 12.1849V6.57278C1.0112 5.18239 2.14879 4.04479 3.53919 4.04479H18.0752C19.4655 4.04479 20.6031 5.18239 20.6031 6.57278V12.1849H20.6284ZM23.662 9.15133C23.662 10.3648 22.8025 11.4012 21.6396 11.6288V6.57278C21.6396 4.62623 20.047 3.03359 18.1004 3.03359H4.12063C4.34815 1.87072 5.38463 1.0112 6.59806 1.0112H21.134C22.5244 1.0112 23.662 2.14879 23.662 3.53919V9.15133Z"
        fill="black"
      />
      <Path
        d="M3.94355 10.8959C4.78126 10.8959 5.46035 10.2168 5.46035 9.3791C5.46035 8.5414 4.78126 7.8623 3.94355 7.8623C3.10585 7.8623 2.42676 8.5414 2.42676 9.3791C2.42676 10.2168 3.10585 10.8959 3.94355 10.8959Z"
        fill="black"
      />
      <Path
        d="M17.696 10.8959C18.5337 10.8959 19.2128 10.2168 19.2128 9.3791C19.2128 8.5414 18.5337 7.8623 17.696 7.8623C16.8583 7.8623 16.1792 8.5414 16.1792 9.3791C16.1792 10.2168 16.8583 10.8959 17.696 10.8959Z"
        fill="black"
      />
      <Path
        d="M7.63433 6.19341C5.86473 7.963 5.86473 10.7944 7.63433 12.5639C9.40392 14.3335 12.2353 14.3335 14.0049 12.5639C15.7745 10.7944 15.7745 7.963 14.0049 6.19341C12.2353 4.42381 9.40392 4.42381 7.63433 6.19341ZM12.8673 7.60908H11.755C11.8561 7.76076 11.9319 7.963 11.9572 8.16524H12.8673V8.8478H11.9572C11.8308 9.53036 11.2746 10.0612 10.6174 10.0865H10.2382L12.0836 12.1595L11.6286 12.6651L8.77192 9.37868H10.5921C10.9207 9.37868 11.1735 9.15116 11.2999 8.82252H9.10056V8.13996H11.2999C11.1735 7.81132 10.9207 7.5838 10.5921 7.5838H9.10056V6.90125H12.8673V7.60908Z"
        fill="black"
      />
    </Svg>
  );
}
export default SVGComponent;
